import { connect } from "react-redux";
import ImportSpecs from "../../../../Specs/ImportSpecs/ImportSpecs";
import { mapStateToProps } from "../../../../Specs/ImportSpecs";

export default connect(mapStateToProps)(ImportSpecs);
